<template>
  <v-card>
    <v-toolbar flat dense color="primary" dark>
      <v-toolbar-title>{{ $t(`titles.global.${type}`) }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon dark :loading="loading" @click="init">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-toolbar card flat dense color="white">
      <match-filters v-model="localFilters" @search="search" />
      <v-text-field
        v-model="localFilters.match"
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
      />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        disable-initial-sort
        :loading="loading"
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
        :rows-per-page-items="[5, 10]"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="primary"
              class="mr-1"
              @click="openView(props.item.id)"
            >
              visibility
            </v-icon>
            <v-icon
              v-if="can('edit', 'match')"
              color="success"
              @click="setOne(props.item.id)"
            >
              edit
            </v-icon>
          </td>
          <td class="text-xs-center" style="min-width: 130px">
            {{ props.item.date }}
          </td>
          <td class="text-xs-center" style="min-width: 110px">
            {{ props.item.time }}
            <span
              v-if="props.item.wtz && props.item.wtz != $store.state.offset"
              style="font-size: 11px"
              >{{ ` (GMT ${props.item.wtz})` }}</span
            >
          </td>
          <td>
            <v-chip v-if="props.item.homeTeamName" small color="transparent">
              <v-avatar v-if="props.item.homeTeamLogo" size="32">
                <img :src="props.item.homeTeamLogo" alt />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ props.item.homeTeamName }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="props.item.hometeamCategoryName"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ props.item.hometeamCategoryName.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
            <span v-else>-</span>
          </td>
          <td>
            <v-chip v-if="props.item.visitorTeamName" small color="transparent">
              <v-avatar v-if="props.item.visitorTeamLogo">
                <img :src="props.item.visitorTeamLogo" />
              </v-avatar>
              <v-list-tile-content>
                <v-list-tile-title class="body-1">
                  {{ props.item.visitorTeamName }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  v-if="props.item.visitorteamCategoryName"
                  class="caption primary--text text--lighten-1 text-truncate"
                >
                  {{ props.item.visitorteamCategoryName.join(', ') }}
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-chip>
            <span v-else>-</span>
          </td>
          <td>{{ props.item.type }}</td>
          <td style="min-width: 350px">
            <template
              v-if="props.item.categoryName && props.item.categoryName.length"
            >
              <v-chip
                v-for="(category, index) in props.item.categoryName"
                :key="index + category"
                small
                color="primary"
                class="caption"
                dark
              >
                {{ category }}
              </v-chip>
            </template>
            <span v-else>--</span>
          </td>
          <!-- <td style="min-width:200px">{{props.item.location}}</td> -->
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { debounce } from 'debounce'
import { mapActions } from 'vuex'

import MatchFilters from '@/components/apps/matches/MatchFilters'
export default {
  name: 'MatchList',
  components: {
    MatchFilters,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.date'),
          align: 'center',
          value: 'date',
          sortable: false,
        },
        {
          text: this.$t('fields.global.time'),
          align: 'center',
          value: 'time',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.homeTeam'),
          value: 'homeTeam',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.visitorTeam'),
          value: 'visitorTeam',
          sortable: false,
        },
        {
          text: this.$t('fields.global.type'),
          value: 'type',
          sortable: false,
        },

        {
          text: `${this.$tc('models.category')} / ${this.$tc(
            'models.tournament'
          )}`,
          sortable: false,
        },
        // {
        //   text: this.$t('fields.global.location'),
        //   value: 'location'
        // }
      ]
    },
    items() {
      return this.$store.state.matches[this.type]
        ? this.$store.state.matches[this.type].listObject
        : []
    },
    localFilters: {
      get() {
        return this.$store.state.matches[this.type]
          ? this.$store.state.matches[this.type].filters
          : {}
      },
      set(value) {
        this.$store.commit('matches/setSliderFilters', {
          ...value,
          slider: this.type,
        })
      },
    },
    localPagination: {
      get() {
        return this.$store.state.matches[this.type]
          ? this.$store.state.matches[this.type].paginate
          : {}
      },
      set(value) {
        this.$store.commit('matches/setSliderPagination', {
          ...value,
          slider: this.type,
        })
      },
    },
  },
  watch: {
    'localFilters.match': {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (this.localPagination.page !== 1) this.localPagination.page = 1
          this.init()
        }
      },
    },
    'localPagination.page': {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.init()
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (val, oldVal) {
        if (val !== oldVal) this.init()
      },
    },
  },
  created() {
    const vm = this
    this.init = debounce(function () {
      vm.loading = true
      vm.fetchSliders({ slider: vm.type }).finally(() => {
        vm.loading = false
      })
    }, 700)
    this.init()
  },
  methods: {
    ...mapActions({
      fetchSliders: 'matches/fetchSliders',
    }),
    init() {},

    search() {
      this.localPagination.page = 1
      this.init()
    },
    openView(id) {
      this.$router.push({ name: 'match-view', params: { id, tab: 3 } })
    },
    setOne(id) {
      this.$router.push({ name: 'match-edit', params: { id } })
      // })
    },
  },
}
</script>
